import content from '@/content/projects/0817-thurston-links'

export default content



// WEBPACK FOOTER //
// ./src/content/index.js